// = 'https://portal-dev.unap.cl/apps/uads_app/mopazo/conadi/backend/presentacion/controlador2.php';

const GLOBAL = {
    URL_LOGIN: 'https://uads.unap.cl/conadi/backend/presentacion/controlador.php',
    URL_APP: 'https://uads.unap.cl/conadi/backend/presentacion/index.php',
    ROOT_REF: '/conadi/web/'
}

export default GLOBAL;